import { Injectable } from "@angular/core";

import {
  OrderDataPromiseLookupService,
  SystemConfigPromiseService,
  TraderGroupPromiseLookupService,
  BfxBlotterOrdersContextMenuItem,
  ActiveUserProfilePromiseService,
  BfxFindOrdersContextMenuPromiseService,
  BfxBlotterAction,
} from "shared/cubiq-services";

import {
  BfxBlotterOrdersContextMenuService,
  BfxLadderBlotterOrdersContextMenuEvent,
} from "../bfx-blotter-orders/bfx-blotter-orders-contextmenu.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxLadderBlotterContextMenuEventType } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { OrderData, BenchmarkOrderType, OrderType } from "shared/cubiq-model-multi-asset";
import { BfxBlotterOrdersActionSubject } from "../bfx-blotter-orders/bfx-blotter-orders-action-subject.module";

@Injectable()
export class BfxFindOrdersContextMenuService extends BfxBlotterOrdersContextMenuService {
  constructor(
    protected orderDataService: OrderDataPromiseLookupService,
    protected systemConfigService: SystemConfigPromiseService,
    protected traderGroupService: TraderGroupPromiseLookupService,
    protected activeUserService: ActiveUserProfilePromiseService,
    protected contextMenuService: BfxFindOrdersContextMenuPromiseService,
    actionSubject: BfxBlotterOrdersActionSubject,
  ) {
    super(
      orderDataService,
      systemConfigService,
      traderGroupService,
      activeUserService,
      contextMenuService,
      actionSubject,
    );
  }

  public buildMenu(
    blotter: any,
    pageX: number,
    pageY: number,
    selectedIds: Array<string>,
    selectedItems?: Array<object> | null,
  ): void {
    if ((selectedIds && selectedIds.length > 0) || (selectedItems && selectedItems.length > 0)) {
      this.contextMenuService.getMenuItems(selectedIds, this.menuState).then((response: any) => {
        let menuItems = this.postProcessContextMenus(response.menuItems, selectedItems);
        menuItems = this.reduceVisibleMenuItems(menuItems);

        // for template's use
        this.menuItems = menuItems;

        let actionDecorators: any = response.actionDecorators;
        this.showMenuSubject.next(
          new BfxLadderBlotterOrdersContextMenuEvent(
            BfxLadderBlotterContextMenuEventType.MENU_SHOW,
            blotter,
            pageX,
            pageY,
            [],
            actionDecorators,
            menuItems,
          ),
        );
      });
    }
  }

  protected postProcessContextMenus(
    menuItems: Array<BfxBlotterOrdersContextMenuItem>,
    selectedItems: Array<any>,
  ): Array<BfxBlotterOrdersContextMenuItem> {
    menuItems.forEach((element) => {
      if (element.actionId == BfxBlotterAction.ACTION_ORDER_DUPLICATE) {
        element.state.enabled =
          element.isEnabled &&
          selectedItems.find((item: any) => {
            let order: OrderData = item as OrderData;
            return (
              order.fixingDetails == null ||
              order.orderType != OrderType.BENCHMARK ||
              (order.orderType == OrderType.BENCHMARK &&
                order.fixingDetails.bmOrderType != BenchmarkOrderType.Standard)
            );
          }) == null;
      } else if (element.actionId == BfxBlotterAction.ACTION_ORDER_RECAP) {
        element.state.enabled =
          element.isEnabled &&
          selectedItems.find((item: any) => {
            let order: OrderData = item as OrderData;
            return order.orderType == OrderType.BENCHMARK || order.orderType == OrderType.BMALGO;
          }) == null;
      }
    });
    return menuItems;
  }
}
